/* global I18n */

import React from "react"
import FaIcon from "components/fa_icon"
import {Tooltip, TooltipContent, TooltipTrigger} from "../tooltip"

function QuizDescription({
  description = "",
  has_been_quizzed,
  last_training_in_words,
  show_coverage,
  set_show_coverage,
  is_completed,
  completed_at,
  score
}) {
  return (
    <div className={
      `embedded-quiz__description ${!has_been_quizzed ? "never-quizzed" : ""}`
    }>
      {is_completed &&
        <Tooltip className="exam-passed-tooltip">
          <TooltipTrigger>
            <div className="exam-passed">
              <div className="circle">
                <FaIcon name={"fa-trophy"}/>
              </div>
              {I18n.t("js.embedded_quiz.exam_passed")}
            </div>
          </TooltipTrigger>
          <TooltipContent>
            <span className="bold">
              {I18n.t("js.listingbox.exam_passed", {
                date: completed_at,
                percentage: score
              })}
            </span>
          </TooltipContent>
        </Tooltip>
      }
      <span className="title" title={description}>
        {description}
      </span>
      {!has_been_quizzed && !show_coverage &&
        <div className="meta">
          <button className="btn btn-text-link"
                  onClick={() => set_show_coverage(true)}>
            {I18n.t("js.embedded_quiz.show_coverage")}
            <FaIcon name={"fa-caret-down"}/>
          </button>
        </div>
      }
      {!has_been_quizzed && show_coverage &&
        <div className="meta">
          <button className="btn btn-text-link"
                  onClick={() => set_show_coverage(false)}>
            {I18n.t("js.embedded_quiz.hide_coverage")}
            <FaIcon name={"fa-caret-up"}/>
          </button>
        </div>
      }
      {!!has_been_quizzed && <p className="meta">
        {I18n.t("js.embedded_quiz.quizzed_time_ago",
          {time: last_training_in_words})}
      </p>}
    </div>
  )
}

export default QuizDescription
